/* Dependencies */
import styled, { css } from 'styled-components';

type CheckboxProps = {
  someChecked?: boolean;
};

const SelectAllCheckbox = styled.span.attrs(() => ({
  className: 'SelectAllCheckbox',
}))<CheckboxProps>`
  ${({ someChecked }) =>
    someChecked &&
    css`
      .legoCheckboxLabel {
        position: relative;
      }

      .legoCheckboxLabel::before {
        background-color: ${({ theme }) => theme.colors.shadeMediumDark};
        border-color: ${({ theme }) => theme.colors.shadeMediumDark};
      }

      .legoCheckboxLabel::after {
        background-color: white;
        content: '';

        position: absolute;
        top: 7px;
        left: 5px;

        height: 2px;
        width: 12px;
      }
    `}
`;

export default SelectAllCheckbox;
